import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from "@/components/ui/dialog";
import nismCert from "@/assets/nism-certificate.jpg";

const HeroSection = () => {
  return (
    <section className="relative overflow-hidden bg-background pt-6">
      {/* Premium Background Pattern */}
      <div className="absolute inset-0 z-0">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] rounded-full bg-accent/5 blur-[120px]" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] rounded-full bg-primary/5 blur-[120px]" />
      </div>

      <div className="container-max px-4 pt-4 pb-4 md:pb-8 relative z-10">
        <div className="flex flex-col items-center text-center mb-16">
          <h1 className="text-[40px] md:text-[76px] font-extrabold leading-[1.1] md:leading-[1.05] tracking-tight text-primary mb-6 animate-fade-in" style={{ animationDelay: '0.1s' }}>
            Study Today.<br />
            <span className="text-gradient-gold whitespace-nowrap">Trade Tomorrow.</span>
          </h1>

          {/* Decorative Gold Line */}
          <div className="w-20 h-1.5 bg-gradient-to-r from-accent to-accent-light rounded-full mb-8 animate-fade-in" style={{ animationDelay: '0.15s' }} />

          <p className="text-[15px] md:text-[20px] text-muted-foreground mb-8 md:mb-10 max-w-[640px] animate-fade-in font-medium leading-[1.6]" style={{ animationDelay: '0.2s' }}>
            Master the financial markets with premium mentorship and institutional-grade strategies. Exclusive access for serious traders.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center animate-fade-in" style={{ animationDelay: '0.3s' }}>
            <Link to="/courses" className="w-full sm:w-auto">
              <Button className="btn-gold h-[52px] md:h-14 w-full sm:px-10 text-[14px] font-bold uppercase tracking-widest group rounded-full sm:rounded-xl active:scale-[0.98] transition-all duration-300">
                EXPLORE COURSES
                <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
              </Button>
            </Link>
          </div>
        </div>

        {/* NISM Certificate Section */}
        <div className="relative animate-fade-in" style={{ animationDelay: '0.4s' }}>
          <div className="max-w-[850px] mx-auto px-4 md:px-0">
            <div className="text-center mb-6">
              <h2 className="text-lg md:text-2xl font-black text-primary uppercase tracking-tight">
                NISM Certified Research Analyst
              </h2>
              <div className="inline-flex items-center gap-2 mt-2 px-3 py-1 bg-accent/10 rounded-full">
                <span className="text-[10px] font-black text-accent uppercase tracking-widest">Official Registration</span>
              </div>
            </div>

            <Dialog>
              <DialogTrigger asChild>
                <div className="group cursor-pointer">
                  <div className="bg-transparent p-0 border-none !border-0 outline-none shadow-none transition-all duration-500 group-hover:scale-[1.01] rounded-2xl md:rounded-[2rem] overflow-hidden flex justify-center">
                    <img
                      src={nismCert}
                      alt="NISM Research Analyst Certificate"
                      className="w-full h-auto rounded-xl md:rounded-[1.5rem] border-none !border-0 outline-none block"
                    />
                    <div className="absolute inset-0 bg-primary/0 group-hover:bg-primary/5 transition-colors duration-500 rounded-2xl md:rounded-[2rem] flex items-center justify-center">
                      <div className="opacity-0 group-hover:opacity-100 transition-opacity bg-white/90 backdrop-blur-md px-6 py-3 rounded-full shadow-xl">
                        <span className="text-xs font-black text-primary uppercase tracking-widest">Click to View Full Certificate</span>
                      </div>
                    </div>
                  </div>
                </div>
              </DialogTrigger>
              <DialogContent className="max-w-[95vw] md:max-w-[90vw] lg:max-w-[1200px] p-0 overflow-hidden bg-transparent border-none shadow-none">
                <img
                  src={nismCert}
                  alt="NISM Research Analyst Certificate Full View"
                  className="w-full h-auto rounded-lg shadow-2xl"
                />
              </DialogContent>
            </Dialog>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
